import { render } from "./InvestProjectsApplication.vue?vue&type=template&id=aad08dea"
import script from "./InvestProjectsApplication.vue?vue&type=script&lang=js"
export * from "./InvestProjectsApplication.vue?vue&type=script&lang=js"

import "./InvestProjectsApplication.vue?vue&type=style&index=0&id=aad08dea&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__